import "./ProjectPages.scss"

import DanielMartinPic from "../../assets/images/Project-7Shifts-hackathon/daniel-martin.png"
import LeilaGolestanhaPic from "../../assets/images/Project-7Shifts-hackathon/leila-golestanha.png"
import VioletWangPic from "../../assets/images/Project-7Shifts-hackathon/violet-wang.png"
import NicholasHuynh from "../../assets/images/Project-7Shifts-hackathon/nicholas-huynh.png"
import LiYuPic from "../../assets/images/Project-7Shifts-hackathon/li-yu.png"
import TaskFlow from "../../assets/images/Project-7Shifts-hackathon/7shifts-hackathon-taskflow.png"
import Sketches from "../../assets/images/Project-7Shifts-hackathon/7shifts-hackathon-sketches.png"
import Demo from "../../assets/images/Project-7Shifts-hackathon/demo.png"

import ProjectHead from "../../assets/images/Project-7Shifts-hackathon/7shifts-hackathon-head.png"
import { HashLink } from "react-router-hash-link"

function ProjectPage7Shifts() {
  return (
    <div className="csp">
      <div className="csp__container">

        <div className="csp__header">
          <div className="csp__header-bg">
            <img className="csp__header-bg-img" src={ProjectHead} alt="project preview" />
          </div>
          <h1 className="csp__project">Project: <span className="csp__name">7Shifts Hackathon</span></h1>
          <h2 className="csp__case-study">Case Study</h2>
        </div>

        <div className="csp__qnav">
          <ul className="csp__qnav-list">
            <li className="csp__qnav-item" >
              <a href="#project-breakdown" className="csp__qnav-link">Project Breakdown</a>
            </li>
            <li className="csp__qnav-item" >
              <a href="#research" className="csp__qnav-link">Research</a>
            </li>
            <li className="csp__qnav-item" >
              <a href="#proposition" className="csp__qnav-link">Proposition</a>
            </li>
            <li className="csp__qnav-item" >
              <a href="#task-flow-sketches" className="csp__qnav-link">Task Flow and Sketches</a>
            </li>
            <li className="csp__qnav-item" >
              <a href="#final-build" className="csp__qnav-link">Final Build</a>
            </li>
          </ul>
        </div>

        <section className="csp__section">
          <div className="csp__anchor" id="project-breakdown"></div>
          <div className="csp__content">
            <h4 className="csp__title">Project Breakdown</h4>

            <div className="csp__section-sub">
              <h5 className="csp__title-sub">Introduction</h5>
              <p className="csp__description">
                This project is a industry hackathon for <a className="csp__links" target="_blank" rel="noreferrer" href="https://www.7shifts.com/">7Shifts</a> that was 
                completed at <a className="csp__links" target="_blank" rel="noreferrer" href="https://brainstation.io/">Brainstation</a> with the collaboration of 3 UX Desingers and 2 Web Developers.
              </p>
              <div className="csp__showcase">
                <div className="csp__visual-container">
                  <div className="csp__group">
                    <span className="csp__group-name">UX Designers</span>
                    <div className="csp__group-container">
                      <div className="csp__participant">
                        <div className="csp__profile">
                          <a className="csp__participant-link" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/danieljcmartin/">Profile Link</a>
                          <img className="csp__profile-img" src={DanielMartinPic} alt="Daniel Martin"/>
                        </div>
                        <a className="csp__participant-name" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/danieljcmartin/">Daniel Martin</a>
                      </div>
                      <div className="csp__participant">
                        <div className="csp__profile">
                          <a className="csp__participant-link" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/leilagolestanha/">Profile Link</a>
                          <img className="csp__profile-img" src={LeilaGolestanhaPic} alt="Leila Golestanha"/>
                        </div>
                        <a className="csp__participant-name" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/leilagolestanha/">Leila Golestanha</a>
                      </div>
                      <div className="csp__participant">
                        <div className="csp__profile">
                          <a className="csp__participant-link" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/violetcwang/">Profile Link</a>
                          <img className="csp__profile-img" src={VioletWangPic} alt="Violet Wang"/>
                        </div>
                        <a className="csp__participant-name" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/violetcwang/">Violet Wang</a>
                      </div>
                    </div>
                  </div>
                  <div className="csp__group">
                    <span className="csp__group-name">Web Developers</span>
                    <div className="csp__group-container">
                      <div className="csp__participant">
                        <div className="csp__profile">
                          <a className="csp__participant-link" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/nickhuynhq/">Profile Link</a>
                          <img className="csp__profile-img" src={NicholasHuynh} alt="Nicholas Huynh"/>
                        </div>
                        <a className="csp__participant-name" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/nickhuynhq/">Nicholas Huynh</a>
                      </div>
                      <div className="csp__participant">
                        <div className="csp__profile">
                          <a className="csp__participant-link" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/li-yu-developer/">Profile Link</a>
                          <img className="csp__profile-img" src={LiYuPic} alt="Li Yu"/>
                        </div>
                        <a className="csp__participant-name" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/li-yu-developer/">Li Yu</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h5 className="csp__title-sub">Problem Space</h5>
              <p className="csp__description">
                7Shifts presented a simple yet complicated problem:
              </p>

              <div className="csp__emphasize">
                <div className="csp__problem-space">Employee turnover rate in the restaurant industry is at an all time high.</div>
              </div>

            </div>
          </div>
        </section>

        <section className="csp__section">
          <div className="csp__anchor" id="research"></div>
          <div className="csp__content">
            <h4 className="csp__title">Research</h4>
            <div className="csp__section-sub">

              <h5 className="csp__title-sub">Initial Research</h5>
              <div className="csp__section-sub-sub">
                <div className="csp__left-bar"></div>
                <div className="csp__right">
                  <p className="csp__description">
                    Turnover rate of 70%, reaching a new high of 140% in 2022 - Forbes
                  </p>
                  <p className="csp__description">
                    More than 70% job positions vacant, and 3 out of 4 employees planning to leave in the next year
                  </p>
                </div>
              </div>

              <p className="csp__description" style={{marginTop: "1rem"}}>
                With the intial research done, we can establish our initial "How Might We":
              </p>

              <div className="csp__emphasize">
                <div className="csp__problem-space">How might we help restaurants hire and retain employees?</div>
              </div>
            
              <h5 className="csp__title-sub">Secondary Research</h5>
              <div className="csp__section-sub-sub">
                <div className="csp__left-bar"></div>
                <div className="csp__right">
                  <p className="csp__description">
                    People think of restaurant industry positions as a stepping stone in their career
                  </p>
                  <p className="csp__description">
                    Lack of sufficient training, 70% of employees feel they do not have hands on training from their managers
                  </p>
                  <p className="csp__description">
                    Lack of team building activities and career progression opportunities
                  </p>
                </div>
              </div>

              <h5 className="csp__title-sub">Summary: Feeling Valued</h5>
              <p className="csp__description">
                All of these issues add up to the overall problem of “feeling valued”.
              </p>
              <p className="csp__description">
                How can we tell a new narrative to current and prospective employees that show upward career mobility?
              </p>
              <p className="csp__description">
                We can now establish our revised "How Might We" based on the secondary research:
              </p>

              <div className="csp__emphasize">
                <div className="csp__problem-space">How might we help managers make their staff feel more valued through digital solutions, in order to improve retention?</div>
              </div>
              
            </div>
          </div>
        </section>

        <section className="csp__section">
          <div className="csp__anchor" id="proposition"></div>
          <div className="csp__content">
            <h4 className="csp__title">Proposition</h4>
            <p className="csp__description">
              After analysing existing features on 7Shifts platform and competitor platform, we have found a way for 7Shifts to standout.
            </p>

            <div className="csp__emphasize">
              <div className="csp__problem-space">Skill Building: Focus on employee infrastructure, with the goal of scaling the business through retaining employees.</div>
            </div>

            <div className="csp__section-sub">
              <h5 className="csp__title-sub">Skill Building</h5>
              <div className="csp__section-sub-sub">
                <div className="csp__left-bar"></div>
                <div className="csp__right">
                  <p className="csp__description">
                    A new feature that focuses on creating opportunities for employees to grow in their career
                  </p>
                  <p className="csp__description">
                    Build towards growing their individual abilities, with the potential for employees to receive promotion
                  </p>
                  <p className="csp__description">
                    Reduce feelings of stagnancy, and show employees the value of building their skills in the restaurant industry as a career
                  </p>
                  <p className="csp__description">
                    Research reinforces that it costs less to train employees than constantly hire, so why not focus on the team you have?
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="csp__section">
          <div className="csp__anchor" id="task-flow-sketches"></div>
          <div className="csp__content">
            <h4 className="csp__title">Task Flow and Sketches</h4>
            <p className="csp__description">
              After analysing existing features on 7Shifts platform and competitor platform, we have found a way for 7Shifts to standout.
            </p>
            <p className="csp__description">
              The task flow to be implemented is then determined keeping in mind user experience with the least user actions.
            </p>

            <div className="csp__visual">
              <div className="csp__visual-container">
                <div className="csp__visual-description"></div>
                <img className="csp__visual-img" src={TaskFlow} alt="task flow"></img>
              </div>
            </div>

            <p className="csp__description" style={{marginTop: "1rem"}}>
              Initial sketches follows soon after to quickly visualize structurally how each page and component will look like.
            </p>

            <div className="csp__visual">
              <div className="csp__visual-container">
                <div className="csp__visual-description"></div>
                <img className="csp__visual-img"  src={Sketches} alt="project sketches"></img>
              </div>
            </div>
          </div>
        </section>

        <section className="csp__section">
          <div className="csp__anchor" id="final-build"></div>
          <div className="csp__content">
            <h4 className="csp__title">Final Build</h4>
            <p className="csp__description">
              With the task flow and the the sketches established, we were able to proceed to build our solution to the problem.
            </p>
            <p className="csp__description">
              Here is a quick link to see the <a className="csp__links" target="_blank" rel="noreferrer" href="https://7shifts-hack-a-thon.netlify.app/dashboard">live page</a>.
            </p>
            <p className="csp__description">
              The project is only built to be functional with Sarah Martin's request.
            </p>

            <div className="csp__visual">
              <div className="csp__visual-container">
                <div className="csp__visual-description"></div>
                <img className="csp__visual-img"  src={Demo} alt="project preview"></img>
              </div>
            </div>
          </div>
        </section>

        <div className="csp__navigate-bottom">
          <HashLink smooth to="/#projects">
            <div className="csp__home">Back to Projects</div>
          </HashLink>
        </div>
      </div>
    </div>
  )
}

export default ProjectPage7Shifts